import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { Skeleton } from "./Skeleton";

const FALLBACK = "/images/fallback.png";

const NextImage = (props: any) => {
  let {
    alt = "image",
    fill,
    src: _src,
    skeleton = false,
    width,
    height,
    fallback,
    ...rest
  } = props;
  const [src, setSrc] = useState(_src);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (src !== _src) {
      setSrc(_src);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_src]);

  if (fill === undefined) {
    fill = width === undefined && height === undefined;
  }

  if (!skeleton) {
    return (
      <Image
        onLoad={() => setLoaded(true)}
        width={width}
        height={height}
        src={src}
        alt={alt}
        fill={fill}
        onError={() => setSrc(fallback || FALLBACK)}
        {...rest}
      />
    );
  }

  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
      className="relative h-full w-full"
    >
      {!loaded && (
        <div className="absolute inset-0 z-10">{Skeleton.Image()}</div>
      )}
      <Image
        onLoad={() => setLoaded(true)}
        width={width}
        height={height}
        src={src}
        alt={alt}
        fill={fill}
        onError={() => setSrc(fallback || FALLBACK)}
        {...rest}
      />
    </div>
  );
};

export default NextImage;
